var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-input', { staticClass: "input-with-select", attrs: { "placeholder": _vm.config.field.placeholder || '' }, model: { value: _vm.inputed, callback: function callback($$v) {
        _vm.inputed = $$v;
      }, expression: "inputed" } }, [_c('el-select', { attrs: { "slot": "prepend", "placeholder": _vm.config.field.placeholder || '' }, slot: "prepend", model: { value: _vm.selected, callback: function callback($$v) {
        _vm.selected = $$v;
      }, expression: "selected" } }, _vm._l(_vm.config.field.options, function (item, index) {
    return _c('el-option', { key: index, attrs: { "label": item.label, "value": item.value } });
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };